import ReactPixel from 'react-facebook-pixel';

// Facebook Pixel initialization
const initFacebookPixel = (pixelId: string) => {
  // const advancedMatching = { email: 'info@assurelis.com' }; // You can add user data here if available
  const options = {
    autoConfig: true,
    debug: process.env.NODE_ENV !== 'production',
  };

  // Check if we have a valid pixel ID before initializing
  if (!pixelId) {
    console.warn(
      'Facebook Pixel ID is not defined. Pixel tracking will not work.'
    );
    // Return dummy functions to prevent errors
    return {
      pageView: () => {},
      track: () => {},
      trackCustom: () => {},
    };
  }

  ReactPixel.init(pixelId, undefined, options);

  // Initial page view
  ReactPixel.pageView();

  return {
    pageView: () => ReactPixel.pageView(),
    track: (event: string, data?: object) => ReactPixel.track(event, data),
    trackCustom: (event: string, data?: object) =>
      ReactPixel.trackCustom(event, data),
  };
};

export default initFacebookPixel;
